// extracted by mini-css-extract-plugin
export default {"WIP":"WIP_WIP__K-5nd","load":"WIP_load__SmvGh"};